export default __webpack_public_path__ + "static/media/17_2.cf34bd54.jpg";